<template>
  <div id="contact">
    <menu-default/>
      <div class="jumbotron jumbotron-fluid">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="title text-center"><i class="fa fa-envelope"></i>  Contato</h1>
            </div>
          </div>
        </div>
      </div>

    <div class="container">
      <div class="row">
        <div class="col-7">
          <contact-form/>
        </div>

      <div class="col-5">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">(14) 3815-3516</li>
              <li class="list-group-item">pubtec@pubtec.com.br</li>
              <li class="list-group-item">Rua Hermínio Marco Calônego, 719 <br/>JD Panorama - Botucatu - SP</li>
            </ul>
      </div>
    </div>

      </div>

    <footer-default/>
  </div>
</template>

<script>
    import menuDefault from "./common/menu-default";
    import footerDefault from "./common/footer-default";
    import contactForm from "./common/contact-form";
    export default {
        name: "Contact",
       components: { menuDefault, footerDefault, contactForm },
    }
</script>

<style scoped>

</style>
